import fillInGapTimespan from "components/pages/schedule/helpers/fillInGapTimespan";
import Block from "domain/Block";

export default function dragToReschedule({ gapFiller }) {
  return function dragToRescheduleClosure({ eventRecords, context }) {
    const cursorPositionX = context.browserEvent.clientX;
    const {
      data: { block },
    } = eventRecords[0];
    const { newResource } = context;

    if (Block.isDowntime(block)) return;

    const line = newResource?.data;
    if (!line) return;

    if (!isMultiScheduling({ eventRecords })) {
      gapFiller.onTaskDrag({
        blockToReschedule: block,
        cursorPositionX,
        line,
      });
    }
    const timespanWithinGap = fillInGapTimespan({ block, gapFiller, line });

    // Every drag sets the width, so that leaving fill-in-the-gap mode mid-drag narrows the block back down.
    const timespan = timespanWithinGap?.durationInSeconds() ? timespanWithinGap : Block.blockTime(block);
    const width = this.timeAxisViewModel.getDistanceForDuration(timespan.durationInSeconds() * 1000);

    context.context.element.style.width = `${width}px`;
  };
}

function isMultiScheduling({ eventRecords }) {
  return eventRecords.length > 1;
}
